import React from 'react';
import { motion } from 'framer-motion';
import { Flame, AlertTriangle } from 'lucide-react';
export function UrgencyBanner() {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="bg-brand-purple text-white py-3 px-4 text-center sticky top-0 z-50 shadow-md" data-id="element-178">
      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-sm sm:text-base font-bold tracking-wide" data-id="element-179">
        <div className="flex items-center gap-2" data-id="element-180">
          <Flame className="w-5 h-5 text-yellow-300" data-id="element-181" />
          <span data-id="element-182">50% OFF — Today Only</span>
        </div>
        <div className="hidden sm:block w-1 h-1 bg-white/50 rounded-full" data-id="element-183"></div>
        <div className="flex items-center gap-2" data-id="element-184">
          <AlertTriangle className="w-5 h-5 text-yellow-300" data-id="element-185" />
          <span data-id="element-186">Limited stock available</span>
        </div>
      </div>
    </motion.div>;
}